import { erpAxios } from '.';

const getIbsPustanjaKreditaAnalitika = async (brojZahtjeva) => {
  const { data } = await erpAxios(`/ibsPustanjaKreditaAnalitika/${brojZahtjeva}`);
  return data;
};

export default getIbsPustanjaKreditaAnalitika;
